import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { InView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { IsControl, IsChallenger } from 'Redux/ducks/split-test';
import { fetchOnSale } from 'Redux/ducks/algolia-calls';
import Backtotopbutton from 'Components/Utility/Mobile/Backtotopbutton';
import Loading from 'Components/Utility/Loading';
import Meta from 'Components/Utility/SEO/Meta';
import NotFound from 'Components/NotFound/NotFound';
import TakeOver from 'Components/Banner/TakeOver';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import DefaultSale from 'Containers/OnSale/DefaultSaleTemplate';
import OnSaleTemplate from 'Containers/OnSale/OnSaleTemplate';
import SearchPage from 'Components/Search/Search';

import 'Components/OnSale/OnSale.scss';

const messages = defineMessages({
  title: {
    id: 'onsalesections.seotitle',
    defaultMessage: 'PC Game Deals - Games & Steam Keys On Sale',
  },
  desc: {
    id: 'onsale.seodesc',
    defaultMessage: 'Top Sellers on great PC, Mac, and Linux games from over 750 top publishers. Whether you\'re looking for the latest, greatest games, or one of our exclusive bundles, we are Fanatical about always bringing you the best deals on the planet.',
  },
});

const OnSaleSectionsContainer = () => {
  const [algoliaData, setAlgoliaData] = useState(null);

  const location = useSelector(state => state?.router?.location) || {};

  const { formatMessage } = useIntl();

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchOnSale();
      setAlgoliaData(data);
    };

    if (IsControl('OnSalePageListingV3')) {
      fetchData();
    }
  }, []);

  if (IsChallenger('OnSalePageListingV3')) {
    return (
      <SearchPage location={location} />
    );
  }

  if (getUrlParameter('page')) return <NotFound redirect="on-sale" />;

  // null is the default state and implies component hasn't loaded
  if (algoliaData === null) return <Loading />;

  if (isEmpty(algoliaData)) return <NotFound />;

  const {
    topSellers,
  } = algoliaData;

  const useSaleTemplate = false;

  const majorSaleName = algoliaData?.majorSale?.displayName;

  return (
    <React.Fragment>
      <Meta
        title={majorSaleName || formatMessage(messages.title)}
        description={formatMessage(messages.desc)}
        url="on-sale"
        hits={topSellers}
        pageType="CollectionPage"
        brandTitle={!!majorSaleName}
      />
      <TakeOver appearsOn="on_sale" />

      <main className="OnSalePage">
        <section className="container OnSalePage__titleSection">
          <InView>
            {({ inView, ref }) =>
              <div ref={ref}>
                <h1 className="pb-3">
                  <FormattedMessage id="onsalesections.header" defaultMessage="PC Game Deals" />
                </h1>

                {!inView &&
                  <div className="d-block d-sm-none">
                    <Backtotopbutton />
                  </div>
                }
              </div>
            }
          </InView>

          <p className="seo-blurb-text mb-0">
            <FormattedMessage
              id="onsalesections.intro"
              defaultMessage="Don’t miss out on some of the best and most popular deals on sale right now at Fanatical. You can find top selling PC games and bundles from official partners. Not looking for games? You can also find eBooks, eLearning and software at bargain prices - perfect for everyone!"
            />
          </p>
        </section>

        {useSaleTemplate ?
          <OnSaleTemplate algoliaData={algoliaData} />
          :
          <DefaultSale algoliaData={algoliaData} />
        }

      </main>
    </React.Fragment>
  );
};

export default OnSaleSectionsContainer;
